export default __webpack_public_path__ + "static/6-926acb47bb991e9566f41a9e9ab22bca.webp";